import { isLoadingSelector, errorSelector } from '../utils/helperSelectors';
export const caregiversSelector = (state) => state.accountCaregivers.data || [];
export const adminCaregiversSelector = (state) => caregiversSelector(state).filter((caregiver) => !caregiver.is_read_only);
export const areCaregiversLoadingSelector = isLoadingSelector('accountCaregivers');
export const caregiversErrorSelector = errorSelector('accountCaregivers');
//# sourceMappingURL=selectors.js.map